<template> 
  <div 
    v-if="property"
    class="div property-container">
    <!--Header-->
    <v-row class="white">
      <ShowHeader :property="property"/>
      <!--Tabs-->
      <v-col cols="12" class="py-0 px-12">
        <v-tabs v-model="tabs">
          <v-tab
            :disabled="!property.contracts.length">
            {{ $t('property.detail.tabs.contract') }}
          </v-tab>
          <v-tab>
            {{ $t('property.detail.tabs.characteristics') }}
          </v-tab>
          <v-tab>
            {{ $t('property.detail.tabs.taxes') }}
          </v-tab>
          <v-tab>
            {{ $t('property.detail.tabs.fixes') }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <!--Finish Header-->
    <div class="background">  
      <div class="col-12 pa-0" style="height:100vh;">
        <ShowContract 
          v-if="tabs == 0"
          :key="tabs"
          :property="property"/>
        <ShowCharacteristics 
          v-if="tabs == 1"
          :key="tabs" 
          :property="property"/>
        <Taxes 
          v-if="tabs == 2"
          @reload="fetchProperty($route.params.id)"
          :key="tabs" 
          :property="property"/>
        <Fixes 
          v-if="tabs == 3"
          :key="tabs" 
          :property="property"/>
      </div>
    </div>
  </div>
</template>

<script>
import ShowHeader from '@/components/properties/ShowHeader'
import ShowCharacteristics from '@/components/properties/ShowCharacteristics'
import ShowContract from '@/components/properties/ShowContract'
import Taxes from '@/components/properties/Taxes'
import Fixes from '@/components/properties/Fixes'
import { Property } from '@/graphql/queries/property'

export default {
  name: "Property",
  components:{
    ShowHeader,
    ShowCharacteristics,
    ShowContract,
    Taxes,
    Fixes
  },
  data() {
    return {
      tabs: 1,
      property: null
    }
  },
  mounted() {
    this.fetchProperty(this.$route.params.id)
  },
  methods:{
    fetchProperty(id) {
      this.$apollo.query({
        query: Property,
        variables: {
          id: id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.property = res.data.property
      })
    }
  },
  watch: {
    tabs() {
      this.fetchProperty(this.$route.params.id)
    }
  }
}
</script>
